module.exports = __webpack_public_path__ + "img/dizhi.7df96bd5.svg";